export function AdminApp() {
  return <div>Admin App</div>;
}
